import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makeHotjarClient } from "../../lib/analytics/hotjar";
import { makeMixpanelClient } from "../../lib/analytics/mixpanel";
import { makeGA4Client } from "../../lib/analytics/ga4";

export function useThePortalAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    // Google Analytics
    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "theportal",
        },
      });

      analytics.addClient(ga4Client);
    }

    // Hotjar
    if (variables.hotjarId && variables.hotjarSnippetVersion) {
      const hotjarClient = makeHotjarClient({
        hotjarTrackingID: variables.hotjarId,
        hotjarSnippetVersion: variables.hotjarSnippetVersion,
      });

      analytics.addClient(hotjarClient);
    }

    // Mixpanel
    if (variables.mixpanelToken) {
      const mixpanelClient = makeMixpanelClient({
        token: variables.mixpanelToken,
        debug: variables.debug,
      });

      analytics.addClient(mixpanelClient);
    }
  }, [analytics, config.environment]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
    hotjarId: null,
    hotjarSnippetVersion: null,
    debug: true,
    mixpanelToken: null,
  },
  staging: {
    ga4TrackingId: "G-QKYPZH3PC6",
    hotjarId: 2005679,
    hotjarSnippetVersion: 6,
    debug: true,
    mixpanelToken: "5f75336d2da8f13b69edb312d4056182",
  },
  production: {
    ga4TrackingId: "G-BCWSQ5V4DE",
    hotjarId: 2003465,
    hotjarSnippetVersion: 6,
    debug: false,
    mixpanelToken: "33d4dfb7ce588749a4fac972c611d8f1",
  },
};
